<div
  class="c-stamp-progress"
  [ngClass]="event.total <= MAX_STAMPS_PER_LINE ? 'c-stamp-progress--one-line' : ''">
  <div class="c-stamp-progress__count">{{ event.current }}/{{ event.total }}</div>

  <div class="c-stamp-progress__container">
    <div
      class="c-stamp-progress__row"
      [ngClass]="[event.total <= MAX_STAMPS_PER_LINE ? '' : 'wrap', event.total === SPLIT_STAMPS ? 'split' : '']">
      @for (free of freeStampsArray; track free) {
        <div
          class="c-stamp"
          theming
          themingGroup="slotcard"
          themingAsset="stamp-free"
          [themingOverride]="event?.assets"></div>
      }

      @for (stamp of objectiveStampsArray; track stamp; let i = $index) {
        <div
          class="c-stamp c-stamp-{{ i }}"
          theming
          themingGroup="slotcard"
          [themingAsset]="event.current - event.properties.freesteps >= i + 1 ? 'stamp-on' : 'stamp-off'"
          [themingOverride]="event?.assets"></div>
      }
    </div>
  </div>
</div>
